import React from 'react';
import { Space } from '../../components/utils/utils';
import { Link } from 'react-router-dom';

import './footer.scss';
import '../../theme/global.scss';
import logo from '../../images/icon.png';
import { ROUTES } from '../../routing/routes';

const Footer = () => {
  return (
    <footer>
      <div className='aligned-left'>
        <p className='subheading-light bold'>Contact</p>
        <Space vertical={'5vh'} />
        <div>
          <a className='small-light' href='tel:0721151699'>
            Sunați-ne
          </a>
          <Space vertical={10} />
          <a className='small-light' href='mailto:office@sirar.ro'>
            Trimiteți-ne un email
          </a>
        </div>
      </div>
      <div>
        <img src={logo} alt='sirar_logo' />
      </div>
      <div className='content-aligned-right'>
        <p className='subheading-light bold'>Informații</p>
        <Space vertical={'5vh'} />
        <div>
          <Link className='footer-link' to={ROUTES.DATA_PROCESSING_AGREEMENT}>
            Acord de prelucrare a datelor
          </Link>
          <Space vertical={10} />
          <Link className='footer-link' to={ROUTES.TERMS_AND_CONDITIONS}>
            Politica de cookies
          </Link>
          <Space vertical={10} />
          <Link className='footer-link' to={ROUTES.TERMS_AND_CONDITIONS}>
            Termeni si conditii
          </Link>
          <Space vertical={10} />
          <Link className='footer-link' to={ROUTES.PRIVACY_POLICY}>
            Politica de confidentialitate
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
